import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  level: 1,
  className: '',
  fontSize: 'text-3xl md:text-4xl lg:text-6xl',
};

const propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  className: PropTypes.string,
  fontSize: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function PrimaryTitle({ level, className, fontSize, children }) {
  const Level = `h${level}`;

  return (
    <Level
      className={clsx(fontSize, 'font-extrabold tracking-tight', className)}
    >
      <div className="leading-10 md:leading-snug">{children}</div>
    </Level>
  );
}

PrimaryTitle.defaultProps = defaultProps;
PrimaryTitle.propTypes = propTypes;
